import { Modalable, ResponseStatus } from './modalable';

export class Materials implements Modalable {
    static MODAL_ID = 'materialModal';

    bypassCheck = false;
    status: ResponseStatus;

    getStatus(): ResponseStatus {
        return this.status;
    }

    getModalId(): string {
        return Materials.MODAL_ID;
    }

    canBypassCheck(): boolean {
        return this.bypassCheck;
    }
}
